// removed by extract-text-webpack-plugin
module.exports = {"container":"src-lib-components-__MainView__container--TD_M_","content":"src-lib-components-__MainView__content--VSpVj","padded":"src-lib-components-__MainView__padded--34K5W","grayBackground":"src-lib-components-__MainView__grayBackground--fPt9Q","hasSubBar":"src-lib-components-__MainView__hasSubBar--2wE5N","dimmer-content":"src-lib-components-__MainView__dimmer-content--2G_g8","dimmer-content-inner":"src-lib-components-__MainView__dimmer-content-inner--24v81","dimmer-description":"src-lib-components-__MainView__dimmer-description--3GokD"};


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/MainView.less
// module id = 1856
// module chunks = 0